import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuncionalidadeService } from 'src/app/service/funcionalidade.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { Segmento } from 'src/app/page/segmento/segmento';
import { Funcionalidade } from './funcionalidade';

@Component({
  selector: 'app-funcionalidade-form',
  templateUrl: './funcionalidade-form.component.html',
  styleUrls: ['./funcionalidade-shared.scss'],
})
export class FuncionalidadeFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;
  segmentos: Segmento[] = [];

  constructor(
    private fb: FormBuilder,
    private service: FuncionalidadeService,
    private segmentoService: SegmentoService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarForm();
    this.carregarSegmentos();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarForm(funcionalidade?: Funcionalidade) {
    this.formulario = this.fb.group({
      id: [funcionalidade?.id ?? null],
      descricao: [funcionalidade?.descricao ?? '', Validators.required],
      value: [funcionalidade?.value ?? ''],
      segmentoId: [funcionalidade?.segmentoId ?? null, Validators.required],
      valor: [funcionalidade?.valor ?? null],
      vendaAvulsa: [funcionalidade?.vendaAvulsa ?? false],
      ativo: [funcionalidade?.ativo ?? true],
    });
  }

  carregarSegmentos() {
    this.segmentoService.listarAtivos().subscribe(resp => this.segmentos = resp ?? []);
  }

  carregar(id: number) {
    this.carregando = true;
    this.service.buscarPorId(id).subscribe(func => {
      this.montarForm(func);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Funcionalidade não encontrada.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    if (this.formulario.invalid) {
      return;
    }
    const payload: Funcionalidade = { ...this.formulario.value };
    if (payload.vendaAvulsa !== true) {
      payload.valor = null;
    }
    this.service.salvar(payload).subscribe(salvo => {
      this.snackBar.open('Funcionalidade salva com sucesso.', 'OK', { duration: 2500 });
      this.formulario.patchValue({ id: salvo.id });
    }, err => this.snackBar.open(err.error?.message ?? 'Erro ao salvar funcionalidade.', 'ERRO', { duration: 3000 }));
  }

  limpar() {
    this.router.navigate(['/funcionalidade/form']);
    this.montarForm();
  }

  voltarConsulta() {
    this.router.navigate(['/funcionalidade/consulta']);
  }
}
